import { render, staticRenderFns } from "./DefaultButtons.vue?vue&type=template&id=7a71492a"
import script from "./DefaultButtons.vue?vue&type=script&lang=ts"
export * from "./DefaultButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports